import { useQuery } from '@tanstack/react-query'

import { apiFetch } from './apiFetch'

export const useShowings = (projectId) =>
  useQuery({
    queryKey: ['showings', projectId],
    queryFn: () => apiFetch(`/api/user/projects/${projectId}/showings`),
    enabled: !!projectId,
    retry: false,
  })
